<template>
  <div>
    <el-popover placement="bottom-start" width="200" v-model="visible">
      <slot v-if="$slots && !noChildren" />
      <div class="p-3" v-else>
        <p>{{ title || 'Are you sure to leave this page?' }}</p>
        <K2Row style="text-align: right; margin: 0" justify_content="flex-end" align="center" space-between="true">
          <K2Button theme="2" size="mini" type="primary" @onclick="handleCancel()" v-if="!hideCancel">
            <K2Text :color="uiVariable.color.button1">cancel</K2Text>
          </K2Button>
          <K2Button type="text" size="mini" @onclick="handleConfirm()">
            <K2Text :color="uiVariable.color.purple" bold="true">confirm</K2Text>
          </K2Button>
        </K2Row>
      </div>
      <K2Button size="small" :theme="theme" slot="reference" :background="background" :style="styles">
        <K2Icon :name="icon" :color="uiVariable.color.error" v-if="icon" />
        <K2Text v-else :color="color || uiVariable.color.error">{{ label }}</K2Text>
      </K2Button>
    </el-popover>
  </div>
</template>

<script>
import uiVariable from '../../config/uiVariable'
import K2Button from '../k2Button/k2Button'
import K2Text from '../k2Text/k2Text'
import K2Row from '../k2Row/k2Row'
import K2Icon from '../k2Icon/k2MAIcon'

export default {
  name: 'K2Confirm',
  props: ['title', 'confirmText', 'cancelText', 'color', 'theme', 'label', 'confirm', 'icon', 'background', 'hideCancel', 'children', 'noChildren', 'styles'],
  components: { K2Icon, K2Row, K2Text, K2Button },
  data() {
    return {
      uiVariable: uiVariable,
      textColor: this.color,
      visible: false,
    }
  },
  created() {},
  methods: {
    handleConfirm() {
      this.visible = false
      this.$emit('confirm')
    },
    handleCancel() {
      this.visible = false
    },
    showAlert() {
      console.log('showAlert')
    },
  },
}
</script>
